export function shouldRefreshRestaurantCoordinates({
  isEdit,
  isCoordinateUptodate,
  latitude,
  longitude,
  persistedAddressFields,
  addressFields,
}) {
  if (isCoordinateUptodate && latitude && longitude) {
    return false;
  }

  if (!isEdit) {
    return true;
  }

  return persistedAddressFields !== null
    && persistedAddressFields !== addressFields;
}
